import React, { useEffect, useState } from "react";
import { io } from "socket.io-client";
import Swal from "sweetalert2";
import socket from "../../services/socket";
const NotificationModal = () => {
  const [message, setMessage] = useState(null);
  useEffect(() => {
    // const socket = io(process.env.REACT_APP_SOCKET_URL); // Ensure correct backend URL
    socket.on("timeout_warning", (data) => {
      setMessage({
        title: "Timeout Warning",
        body: data.message || "A user has been inactive for 30 minutes.",
      });
    });
    socket.on("user_logged_out", (data) => {
      setMessage({
        title: "User Logged Out",
        body: data.message || "A user has been automatically logged out.",
      });
    });
    return () => {
      socket.disconnect();
    };
  }, []);
  useEffect(() => {
    if (message) {
      Swal.fire({
        title: message.title,
        text: message.body,
        icon: "info",
        showConfirmButton: false,
        showCloseButton: true,
      });
    }
  }, [message]);
  return null;
};
export default NotificationModal;









